import api from './api';

// Steam起動ログを記録
export const logSteamLaunch = async (gameId: number) => {
  try {
    await api.post('/log/steam-launch/', { game_id: gameId });
  } catch (error) {
    // ログ記録の失敗は無視
  }
};
